import React, { useMemo } from 'react'
import styles from '../styles'
import { useHistory, NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { theme } from '../../theme'
import { Button, Dropdown, Icon, Menu } from 'semantic-ui-react'
import { SIGN_IN_STATE, STUDENT, FAST, GOOGLECHANNEL, APPLECHANNEL, PARENT } from '../../constants'
import _ from 'lodash'
import { Trans } from 'react-i18next'
import { logout, setSignInState } from '../../redux/Dashboard/UserReducer'
import { clearClassroom } from '../../redux/Classroom/ClassroomReducer'
import { WHITE } from '../../colors'
import RoutingController from '../Meerkat/RoutingController'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const mainTexts = [
  { title: 'BOLT+/RVR+/Mini', url: '/edurobots' },
  { title: 'Blueprint', url: '/blueprint' },
  { title: 'indi', url: '/indi' },
  { title: 'littleBits', url: '/littlebits' },
  { title: 'Competitions', url: '/sgc', key: 'navbar.competitions' }]

const color = WHITE

const MenuStyle = {
  color: 'white',
  fontSize: '1.3rem',
  fontWeight: 1
}

const MainNavbar = ({ baseUrl }) => {
  const themeMode = theme.dark
  const history = useHistory()
  const dispatch = useDispatch()
  const { search } = useLocation()

  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )

  const { user, isLoggedIn, signInState, admin, classType } = useSelector(state => state.authentication)
  const { mainNavbar } = useSelector(state => state.page)
  const { classroom } = useSelector(state => state.classroom)

  const incompleteUser = user.confirmedAt === null || signInState === SIGN_IN_STATE.MISSING_INFO || _.isEmpty(user.persona)

  const mainHeader = useMemo(() => {
    return classType === FAST ? [mainTexts[0]] : mainTexts
  }, [classType])

  const updateInfo = () => {
    if (user.registrationChannel === GOOGLECHANNEL || user.registrationChannel === APPLECHANNEL) {
      changeStateAndGo(SIGN_IN_STATE.SSO_CHOOSE_ROLE)
    } else if (_.isEmpty(user.persona)) {
      changeStateAndGo(SIGN_IN_STATE.MISSING_ROLE)
    } else {
      changeStateAndGo(SIGN_IN_STATE.MISSING_INFO)
    }
  }

  const changeStateAndGo = (nextState) => {
    dispatch(setSignInState(nextState))
    history.push(`/signup/${nextState}`)
  }

  const logOut = (e) => {
    e.preventDefault()
    dispatch(logout())
    dispatch(clearClassroom())
    history.push('/sphero/home')
  }

  const handleRouting = (url) => {
    history.push(url)
  }

  return (
    <>
      {mainNavbar && (
        <div style={{ ...styles.betweenStyle, height: '5rem', padding: '0.5rem 1.5rem 0 1.5rem', color: 'white', backgroundColor: theme.dark.foreground }}>
          <RoutingController />
          <div>
            <img src='/images/Logo.png' style={{ width: '9rem', cursor: 'pointer' }} onClick={() => { history.push('/landing') }} />
          </div>
          {searchParams.get('previous') === 'code'
            ? <></>
            : (
              <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', fontSize: '1.313rem', paddingRight: '1.5rem', height: '100%' }}>
                {mainHeader.map(({ title, url, key }) => (
                  <div
                    key={url}
                    onClick={() => handleRouting(url)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      fontWeight: `/${baseUrl}` === url ? 'bold' : 1,
                      height: '100%',
                      padding: '1.7rem',
                      borderTopRightRadius: '0.5rem',
                      borderTopLeftRadius: '0.5rem',
                      fontSize: '1.25rem',
                      backgroundColor: `/${baseUrl}` === url && themeMode.primary.default
                    }}
                  >
                    {key ? <Trans i18nKey={key}>{title}</Trans> : title}
                  </div>
                ))}
                <Menu.Menu style={{ ...styles.centerStyle, fontWeight: 1, height: '100%' }}>
                  {isLoggedIn &&
                    <Menu.Item
                      name='user'
                      className='top-nav-bar'
                      style={{ height: '100%' }}
                    >
                      <Dropdown className='top-nav-bar' style={{ color: 'white', display: 'flex', alignItems: 'center', height: '100%' }} text={classroom?.classType === FAST ? `${user.firstName} ${user.lastName}` : user.username} icon={<Icon name='chevron down' color='white' style={{ marginLeft: '0.5rem' }} />}>
                        <Dropdown.Menu style={{ backgroundColor: theme.dark.foreground }}>
                          {incompleteUser && <Dropdown.Item style={MenuStyle} onClick={updateInfo}><Trans i18nKey='navbar.complete_login'>Complete Login</Trans></Dropdown.Item>}
                          {(classroom?.classType !== FAST || user.persona !== STUDENT) && <Dropdown.Item as={NavLink} style={MenuStyle} to='/profile/settings'><Trans i18nKey='navbar.profile' /></Dropdown.Item>}
                          {(classroom?.classType !== FAST || user.persona !== STUDENT) && <Dropdown.Item as={NavLink} style={MenuStyle} to='/profile/notifications'><Trans i18nKey='navbar.messages' /></Dropdown.Item>}
                          {admin && <Dropdown.Item as={NavLink} to='/moderation' style={MenuStyle} text={<Trans i18nKey='navbar.moderate'>Moderate</Trans>} />}
                          <Dropdown.Item as={NavLink} to={`${user.persona !== PARENT ? '/edurobots/classrooms' : '/edurobots/family'}`} style={MenuStyle} text={<Trans i18nKey='central.header.My_Classes' />} />
                          <Dropdown.Item as={NavLink} to='/edurobots/my_content/programs' style={MenuStyle} text={<Trans i18nKey='central.header.My_Content' />} />
                          <Dropdown.Item text={<Trans i18nKey='navbar.sign_out' />} style={MenuStyle} onClick={logOut} />
                        </Dropdown.Menu>
                      </Dropdown>
                    </Menu.Item>}
                  {!isLoggedIn &&
                    <Menu.Item
                      href='/signin'
                      as='a'
                      header
                      name='user'
                      className='top-nav-bar'
                    >
                      <Button
                        style={{
                          color,
                          fontSize: '1.2rem',
                          fontWeight: 'bold',
                          border: '1px solid rgb(0, 178, 227)',
                          backgroundColor: baseUrl ? 'transparent' : themeMode.primary.default
                        }}
                      >
                        <Trans i18nKey='button.sign_in' />
                      </Button>
                    </Menu.Item>}
                </Menu.Menu>
              </div>)}
        </div>
      )}
    </>
  )
}

export default MainNavbar
